/**
 * @param key {string} key
 * @param value {any}
 */
export const setLocalStorageItem = (key, value) => {
  try {
    window.localStorage.setItem(key, value);
  } catch (ex) { console.log("localStorage exception", ex); }
}

/**
 * @param key {string} key
 */
export const getLocalStorageItem = (key) => {
  let item = null;
  try {
    const value = window.localStorage.getItem(key);
    if (value) {
      item = JSON.parse(value);
    }
  } catch (ex) { console.log("localStorage exception", ex); }
  return item
}

/**
 * @param key {string} key
 * @param value {any}
 */
export const setSessionStorageItem = (key, value) => {
  try {
    window.sessionStorage.setItem(key, value);
  } catch (ex) { console.log("sessionStorage exception", ex); }
}
/**
 * @param key {string} key
 */
export const removeSessionStorageItem = (key) => {
  try {
    window.sessionStorage.removeItem(key);
  } catch (ex) { console.log("sessionStorage removeItem exception", ex); }
}

/**
 * @param key {string} key
 * @param withParse {boolean}
 */
export const getSessionStorageItem = (key, withParse = true) => {
  let item = null;
  try {
    const value = window.sessionStorage.getItem(key);
    item = (value && withParse) ? JSON.parse(value) : value;
  } catch (ex) { console.log("sessionStorage exception", ex); }
  return item
}
